import { ref } from "vue";
import { useMiniRentaVariator } from "./use-mini-renta-variator";

export type VariatorArgs = {
    containerEl: HTMLElement;
    badgeEl: HTMLElement;
    snapPoints?: number[];
};

const getClosest = (array: number[], value: number) => {
    return array.reduce((prev, curr) => (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev));
};

const getIndex = (array: number[], value: number): number => {
    const closest = getClosest(array, value);

    return array.indexOf(closest);
};

export const useVariatorHelpers = (variatorArgs: VariatorArgs) => {
    const { isMiniRentaSmallBp } = useMiniRentaVariator();
    const args = ref<VariatorArgs>(variatorArgs);

    const getPoints = () => {
        const { containerEl, badgeEl, snapPoints } = args.value;

        const containerWidth = containerEl.offsetWidth - badgeEl.offsetWidth;
        const snapSpacing = containerWidth / (snapPoints.length - 1);

        const arr: number[] = snapPoints.map((_, i) => {
            if (i === 0 || (isMiniRentaSmallBp.value && i === 1)) {
                return 0;
            } else if (i === snapPoints.length - 1) {
                return containerWidth;
            } else {
                return Math.round(i * snapSpacing);
            }
        });

        return arr;
    };

    const points = ref(getPoints());

    const getXByStepNumber = (stepNumber: number): number => {
        return points.value[args.value.snapPoints.indexOf(stepNumber)];
    };

    const getDisplayStepNumber = (currentX: number): number => args.value.snapPoints[getIndex(points.value, currentX)];

    const resize = () => {
        points.value = getPoints();
    };

    return { resize, getXByStepNumber, getDisplayStepNumber, points };
};
